import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../Store';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import AccountPasswordComponent from './component/AccountPasswordComponent';
import AccountSettingsComponent from './component/AccountSettingsComponent';
import css from './account.module.scss';

/**
 * @author noone
 */
export default function AuftragSearch() {

    const navigate = useNavigate();

    const auth = useSelector((state: RootState) => state.authSlice.auth);

    const [view, setView] = useState<'password' | 'settings'>('password');

    return (
        <>
            <LandingpageHeader />

            <div className="container-fluid">

                <div className={css.accountContainer}>
                    <div>
                        <button
                            onClick={() => {
                                navigate({
                                    pathname: "/",
                                    search: ""
                                });
                            }}

                            style={{ marginBottom: "20px" }}
                            className=' btn btn-outline-primary'
                        >
                            <i className="bi bi-house"></i>
                        </button>


                        <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px" }}>
                            <button className="btn btn-outline-primary" onClick={() => setView('password')}>Passwort</button>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "20px" }}>
                            <button className="btn btn-outline-primary" onClick={() => setView('settings')}>Einstellungen</button>
                        </div>

                    </div>
                    <div>

                        <h3>Konto: {auth.user?.email}</h3>

                        {view === 'password' &&
                            <AccountPasswordComponent />
                        }
                        {view === 'settings' &&
                            <AccountSettingsComponent />
                        }
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );

}